//COPIED FROM CONFLUENCE
import window from 'window-or-global';
import { getRte } from '../../../facades/editor';

let bookmark;

/**
 * Stores the currently selected range and scroll position of the editor so we can get back to to it later using
 * restoreBookmark.
 */
const storeBookmark = () => {
	const editor = window.tinymce.activeEditor;
	const vp = getScroll();
	let rngCopy;

	// The editor (iframe) should be given focus at this point to ensure browsers (like IE8) can retrieve the selection.
	// See CONFDEV-2454
	editor.focus();
	//ensure the focus doesn't throw off scroll position in IE.
	const selection = editor.selection;
	const rng = selection.getRng();

	if (rng.cloneRange && typeof rng.cloneRange === 'function') {
		rngCopy = rng.cloneRange();
	} else {
		// If an IE TextRange make a copy, else it will be an IE IHTMLControlRange so store it directly as it can't
		//  be copied.
		rngCopy = (rng.duplicate && rng.duplicate()) || rng;
	}

	bookmark = {
		scrollX: vp.scrollX,
		scrollY: vp.scrollY,
		range: rngCopy,
	};
};

/**
 * Moves the scroll position and selected range in the editor back to where it used to be based on the
 * last call to storeBookmark.
 */
const restoreBookmark = () => {
	const selection = window.tinymce.activeEditor.selection;
	const win = window.tinymce.activeEditor.getWin();

	if (bookmark) {
		restoreScroll(bookmark);
		win.focus();
		selection.setRng(bookmark.range);
	}
	bookmark = null;
};

const getScroll = () => {
	const vp = window.tinymce.DOM.getViewPort(window.tinymce.activeEditor.getWin());
	return {
		scrollX: vp.x,
		scrollY: vp.y,
	};
};

const restoreScroll = (last) => {
	if (last) {
		const win = window.tinymce.activeEditor.getWin();
		win.scrollTo(last.scrollX, last.scrollY);
	}
};

const BookmarkManager = {
	storeBookmark,
	restoreBookmark,
	getScroll,
	restoreScroll,
};

/**
 * This provides a global object for all resources fetched via WRM from Confluence.
 */
export function exportGlobalBookmarkManager() {
	getRte().BookmarkManager = BookmarkManager;
}

export default BookmarkManager;
